import { apiSlice } from "../../apiSlice";

/* ------------------ API Slice ------------------ */
export const bulkSpareImagesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    /* -------- GET IMAGES BY BULK SPARE ID -------- */
    getBulkSpareImages: builder.query({
      query: (request_id) => `/bulk_deals/spares/${request_id}/images`,
      transformResponse: (response) => response.data,

      providesTags: (result, error, request_id) =>
        result
          ? [
              { type: "BulkSpareImages", id: "LIST", request_id },
              ...result.map((img) => ({
                type: "BulkSpareImages",
                id: img.image_id,
              })),
            ]
          : [{ type: "BulkSpareImages", id: "LIST", request_id }],
    }),

    /* -------- POST IMAGE -------- */
    createBulkSpareImage: builder.mutation({
      query: ({ request_id, body }) => ({
        url: `/bulk_deals/spares/${request_id}/images`,
        method: "POST",
        body,
      }),

      invalidatesTags: (result, error, { request_id }) => [
        { type: "BulkSpareImages", id: "LIST", request_id },
      ],
    }),

    /* -------- PATCH IMAGE -------- */
    updateBulkSpareImage: builder.mutation({
      query: ({ request_id, image_id, body }) => ({
        url: `/bulk_deals/spares/${request_id}/images/${image_id}`,
        method: "PATCH",
        body,
      }),

      invalidatesTags: (result, error, { request_id, image_id }) => [
        { type: "BulkSpareImages", id: image_id },
        { type: "BulkSpareImages", id: "LIST", request_id },
      ],
    }),

    /* -------- DELETE IMAGE -------- */
    deleteBulkSpareImage: builder.mutation({
      query: ({ request_id, image_id }) => ({
        url: `/bulk_deals/spares/${request_id}/images/${image_id}`,
        method: "DELETE",
      }),

      invalidatesTags: (result, error, { request_id, image_id }) => [
        { type: "BulkSpareImages", id: image_id },
        { type: "BulkSpareImages", id: "LIST", request_id },
      ],
    }),

  }),
});

/* ------------------ EXPORT HOOKS ------------------ */
export const {
  useGetBulkSpareImagesQuery,
  useCreateBulkSpareImageMutation,
  useUpdateBulkSpareImageMutation,
  useDeleteBulkSpareImageMutation,
} = bulkSpareImagesApiSlice;